var _circle, _path, _path2, _path3, _path4, _path5, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjustTemperatureOn100X100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F5F5F5",
    stroke: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 53.2719L44.9406 54.1696L45.5 53.8951V53.2719H44.5ZM55.5 53.2719H54.5V53.8951L55.0594 54.1696L55.5 53.2719ZM45.5 27.5C45.5 25.0147 47.5147 23 50 23V21C46.4101 21 43.5 23.9102 43.5 27.5H45.5ZM45.5 53.2719V27.5H43.5V53.2719H45.5ZM38.5 64.5C38.5 59.9659 41.1239 56.0427 44.9406 54.1696L44.0594 52.3742C39.5842 54.5705 36.5 59.1741 36.5 64.5H38.5ZM50 76C43.6487 76 38.5 70.8513 38.5 64.5H36.5C36.5 71.9558 42.5442 78 50 78V76ZM61.5 64.5C61.5 70.8513 56.3513 76 50 76V78C57.4558 78 63.5 71.9558 63.5 64.5H61.5ZM55.0594 54.1696C58.8761 56.0427 61.5 59.9659 61.5 64.5H63.5C63.5 59.1741 60.4158 54.5705 55.9406 52.3742L55.0594 54.1696ZM54.5 34.5V53.2719H56.5V34.5H54.5ZM54.5 27.5V34.5H56.5V27.5H54.5ZM50 23C52.4853 23 54.5 25.0147 54.5 27.5H56.5C56.5 23.9101 53.5899 21 50 21V23Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 40C63.0523 40 63.5 39.5523 63.5 39C63.5 38.4477 63.0523 38 62.5 38V40ZM55.5 40H62.5V38H55.5V40Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 33C63.0523 33 63.5 32.5523 63.5 32C63.5 31.4477 63.0523 31 62.5 31V33ZM55.5 33H62.5V31H55.5V33Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 48C63.0523 48 63.5 47.5523 63.5 47C63.5 46.4477 63.0523 46 62.5 46V48ZM54.5 48H62.5V46H54.5V48Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 64.5C57.5 68.6421 54.1421 72 50 72C45.8579 72 42.5 68.6421 42.5 64.5C42.5 60.3579 45.8579 57 50 57C54.1421 57 57.5 60.3579 57.5 64.5Z",
    fill: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 24,
    rx: 1,
    transform: "matrix(-1 0 0 1 51 34)",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustTemperatureOn100X100);
export default __webpack_public_path__ + "static/media/adjust_temperature_on_100x100.f2301b2a3112126157ca3ff221e88783.svg";
export { ForwardRef as ReactComponent };